
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Classical Conclave</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm classic-conclave section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Classical <span >Conclave</span>
            </h2>
            <p>Classical Conclave is an initiative of G H Raisoni Sports and Cultural Foundation to encourage the Indian
                classical Music and Artists.</p>
        </div>
        <div class="row text-justify">
            <div class="widget_title inner-title">
                <h4>CLASSICAL CONCLAVE</h4>
            </div>
            <p>
                Classical Conclave is an initiative of G H Raisoni Sports and Cultural Foundation to encourage
                the Indian classical Music and Artists. Ancient Indians were deeply impressed by the spiritual
                power of music, and it is out of this that Indian classical music was born. Classical music
                performances showcase the heights of musical creativity achieved by individuals through
                decades of rigorous training and discipline. So, they are always extemporaneous and involve
                only rudimentary lyrics (for the refrain portions) and the barest minimum of instrumental
                accompaniment (tabla for rhythm, tanpura for harmonic resonance).
            </p>
            <p>
                Classical Music is an integral part of Indian Culture; GHRSCF is contributing a bit to it by
                encouraging the culture of classical Music. It is all about sharing the language of music with
                society. It is a small step towards enhancement of ancient Indian Culture of Baithak that
                includes classical recitals, make available for the people of society.

            </p>

        </div>
        <div class="widget_title inner-title">
            <h4>PROGRAMS TILL DATE</h4>
        </div>
        <div class="table-responsive">
            <table class="table table-hover table-striped table-effect--primary shadow-soft">
                <thead class="head-table">
                    <tr>
                        <th class="text-no">Sr. No.</th>
                        <th>Date</th>
                        <th>Event</th>
                    </tr>
                </thead>
                <tbody class="tb-hover cust_ser_num">
                    <tr>
                        <td></td>
                        <td>9 <sup>th</sup> September 2023 </td>
                        <td>Classical Conclave by Vocal Performance - Vidushi Aarti Ankalikar</td>
                    </tr>

                    <tr>
                        <td></td>
                        <td>23<sup>rd</sup> June 2023 </td>
                        <td>Classical Conclave by Vocal Performance - Nagpur </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>22<sup>nd</sup> June 2023 </td>
                        <td>Classical Conclave by Vocal Performance - Amravati</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>17<sup>st</sup> June 2022 </td>
                        <td>Siyavar Ramchandra Kee Jay</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>25<sup>th </sup>June 2022 </td>
                        <td>Classical Conclave by Sawani Shende Sathaye</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>21<sup>st</sup> May 2022 </td>
                        <td>Raagas to Riches By Urvashi Shah</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>29<sup>th</sup> April 2023 </td>
                        <td>नृत्याविष्कार</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>9<sup>th</sup> January 2021 </td>
                        <td>Shri. Arvind Upadhye<small>(Venu Naad) </small></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>25<sup>th</sup> July 2020 </td>
                        <td>Ms. Kalyani Deshpande <small>(Melodies of the strings...Light and classical colors of
                                music)</small></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>4<sup>th</sup> July 2020 </td>
                        <td>Hrishikesh Karmarkar <small>(Dilruba playing a unique gift of musical tunes)</small></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>14<sup>th</sup> June 2020 </td>
                        <td>Dr. Rahul Joshi <small>(Homeopath, Singer and Motivator)</small></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>16<sup>th</sup> May 2020 </td>
                        <td>Dr. Sadhana Shiledar <small>(मै निर्गुणी...
                                एक उपशास्त्रीय संगीत की श्याम ईश्वरीय स्वरों के नाम)</small></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>13<sup>th</sup> May 2020 </td>
                        <td>Shri. Bhupaal Panshikar <small>(सितार वादन कोरोना को संघर्ष देने वाले सभी योद्धाओं के
                                प्रोत्साहन अवं धन्यवाद् हेतु)</small></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>26<sup>th</sup> April 2020 </td>
                        <td>Dr. Vivek Bansod <small>(अक्षय तृतीया कीर्तन मंगल वाद्य के साथ शुभ मुहूर्त, शुभ कीर्तन, शुभ
                                कार्यो अतः शुभ विचारों की शुभ शुरवात के लिए)</small></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>9<sup>th</sup> March 2020 </td>
                        <td>Swar Rang By Priti Pandharpurkar</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>24<sup>th</sup> January 2020 </td>
                        <td>Rejuvenating Musical Evening By Konkan Kanya Band</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>5<sup>th</sup> December 2019 </td>
                        <td>Manjusha Kulkarni Patil (Semi Classical Recital, Bhajan, Abhang &amp; Cultural Recital)</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>20<sup>th</sup> October 2019 </td>
                        <td>Urvashi Shah (Classical and Semi Classical Vocal)</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>25<sup>th</sup> October 2019 </td>
                        <td>Vidushi Kalapini Komkali</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>20<sup>th</sup> September 2019 </td>
                        <td>Ms. Kakoli Mukherjee </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>6<sup>th</sup> August 2019 </td>
                        <td>Mrs. Priyanka Abhyankar </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>29<sup>th</sup> June 2019 </td>
                        <td>Smt. Shubhada Deshpande & Pt. Aniruddha Deshpande (Manbhavan Ashadh)</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>29<sup>th</sup> June 2019 </td>
                        <td>Ms. Nirali Kartik (Surmayi Shyam)</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>01<sup>th</sup> May 2019 </td>
                        <td>Gandhar Deshpande & Aditya Modak (Jugalbandi)</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>05<sup>th</sup> April 2019 </td>
                        <td>Shri. Bhupaal Panshikar</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>18<sup>th</sup> Jan 2019 </td>
                        <td>Pt. Prasad Khaparde</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>16<sup>th</sup> Dec 2018</td>
                        <td>Vidushi Aditi Upadhya</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>26<sup>th</sup> Sept. 2016</td>
                        <td>Intercollegiate Light Music Competition </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>13<sup>th</sup> July 2016</td>
                        <td>Abhang Program – Avagha Viththal Viththal</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>11<sup>th</sup> Oct 2015</td>
                        <td>Intercollegiate Light Music Competition </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>28<sup>th</sup> April 2015</td>
                        <td>Workshop on Vocal Music by Vidushi Devaki Pandit</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>27<sup>th</sup> April 2015 </td>
                        <td>Pt. Prasad Khaparde and Vidushi Devaki Pandit</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row row-cols-1 row-cols-lg-3 mt-5">
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/vidushi-aarti-ankalikar" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/aarti_ankalikar_clasi_con.webp"
                                alt="Sanjeev Abhyankar" title="Sanjeev Abhyankar"></a>

                        <h4> Aarti Ankalikar Indian Classical Vocalist - Nagpur</h4>

                        <h5>9<sup>th</sup> September 2023 </h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/sanjeev-abhyankar-nagpur" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-abhynkar-event-ngp.webp"
                                alt="Sanjeev Abhyankar" title="Sanjeev Abhyankar"></a>

                        <h4>Indian Classical Vocal Performance - Nagpur</h4>

                        <h5>23<sup>rd</sup> June 2023 </h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/sanjeev-abhyankar-amravati" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-abhynkar-event-amt.webp"
                                alt="Sanjeev Abhyankar" title="Sanjeev Abhyankar"></a>

                        <h4>Indian Classical Vocal Performance - Amravati</h4>
                        <h5>22<sup>nd</sup> June 2023 </h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/siyavr-ram" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/siyavr-ram.webp"
                                alt="Siyavar Ramchandra Kee Jay" title="Siyavar Ramchandra Kee Jay"></a>

                        <h4>Siyavar Ramchandra Kee Jay</h4>
                        <h5>17<sup>nd</sup> June 2023 </h5>
                    </div>
                </div>
            </div>


            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/sawani-sathaye" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sawani-sathaye.webp"
                                alt="Sawani Shende Sathaye" title="Sawani Shende Sathaye"></a>

                        <h4>Sawani Shende Sathaye</h4>
                        <h5>25<sup>th</sup> June 2022 </h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/raagas-urvashi" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/raagas-urvashi.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Raagas to Riches By Urvashi Shah</h4>
                        <h5>21<sup>st</sup> May 2022 </h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/nrutyavishkar" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ramchandra-gatha .png"
                                alt="Naad Ninaad" title="Naad Ninaad"></a>

                        <h4>नृत्याविष्कार</h4>
                        <h5>29<sup>th</sup> April Saturday 2023 </h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/naad-ninaad" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/naad-ninaad.jpg"
                                alt="Naad Ninaad" title="Naad Ninaad"></a>

                        <h4>Naad Ninaad</h4>
                        <h5>09<sup>th</sup> October 2022 </h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/arvind-upadhye" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/arvind-upadhye.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Shri. Arvind Upadhye</h4>
                        <h5>09<sup>th</sup> January 2021</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/kalyani-deshpande" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kalyani-deshpande.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Ms. Kalyani Deshpande</h4>
                        <h5>25<sup>th</sup> July 2020</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/hrishikesh-karmarkar" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/hrishikesh-karmarkar.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Hrishikesh Karmarkar</h4>
                        <h5>4<sup>th</sup> July 2020</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/online-rahul-joshi" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/online-invitation-rahuljoshi.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Dr. Rahul Joshi </h4>
                        <h5>14<sup>th</sup> June 2020</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/online-sadhana-shiledar" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sadhana-shiledar.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Dr. Sadhana Shiledar</h4>
                        <h5>16<sup>th</sup> May 2020</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/online-bhupaal-panshikar" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupaal-panshikar.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Shri. Bhupaal Panshikar</h4>
                        <h5>13<sup>th</sup> May 2020</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/vivek-bansod" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vivek-bansod-invitation.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Dr. Vivek Bansod</h4>
                        <h5>26<sup>th</sup> April 2020</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/swar-rang" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/swar-banner.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Swar Rang</h4>
                        <h5>9<sup>th</sup> March 2020</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/konkan-kanya" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/konkan-kanya.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Konkan Kanya Band</h4>
                        <h5>24<sup>th</sup> January 2020</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/manjusha-patil" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/manjusha-patil.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Manjusha Kulkarni Patil</h4>
                        <h5>5<sup>th</sup> December 2019</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/vidushi" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-komkali.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Vidushi Kalapini Komkali</h4>
                        <h5>25<sup>th</sup> October 2019</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/urvashi-shah" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/urvashi-shah.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Urvashi Shah</h4>
                        <h5>20<sup>th</sup> October 2019</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/kakoli" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kakoli-mukherjee.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Ms. Kakoli Mukherjee</h4>
                        <h5>20<sup>th</sup> September 2019</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/priyanka" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/priyanka.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Mrs. Priyanka Abhyankar</h4>
                        <h5>06<sup>th</sup> August 2019</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/manbhavan" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/manbhavan.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Manbhavan Ashadh</h4>
                        <h5>21<sup>st</sup> July 2019</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/nirali-kartik" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/niralikartik1.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4> Ms. Nirali Kartik</h4>
                        <h5>29<sup>th</sup> June 2019</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/jugalbandi" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/gandhar-aditya.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Gandhar Deshpande & Aditya Modak</h4>
                        <h5>01<sup>th</sup> May 2019</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/bhupaal-panshikar" class="shadow-inset img-cla">

                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/bhupaal-panshikar1.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Shri. Bhupaal Panshikar</h4>
                        <h5>05<sup>th</sup> April 2019 </h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/prasad-khaparde" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pk1.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Pt. Prasad Khaparde</h4>
                        <h5>18<sup>th</sup> Jan 2019 </h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/aditi-upadhya" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/aditi-upadhya.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Aditi Upadhya</h4>
                        <h5>16<sup>th</sup> Dec 2018</h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/devaki-pandit#prasad-khaparde" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/prasad-khaparde.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Pt. Prasad Khaparde</h4>
                        <h5>27<sup>th</sup> April 2015 </h5>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="hom-trend text-center">
                    <div class="hom-trend-img pgm-div">
                        <a routerLink="/devaki-pandit" class="shadow-inset img-cla">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/devaki-pandit.webp"
                                alt="Urvashi Shah" title="Urvashi Shah"></a>

                        <h4>Pt. Devaki Pandit</h4>
                        <h5>27<sup>th</sup> April 2015 </h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
